export const FETCH_KITCHEN_LIST_LOADING = 'FETCH_KITCHEN_LIST_LOADING';
export const KITCHEN_LIST_DATA = 'KITCHEN_LIST_DATA';
export const FETCH_KITCHEN_LIST_LOADING_ERROR =
  'FETCH_KITCHEN_LIST_LOADING_ERROR';
export const AVAILABLE_KITCHEN_PREP_WORKSHEET_LOADING =
  'AVAILABLE_KITCHEN_PREP_WORKSHEET_LOADING';
export const AVAILABLE_KITCHEN_PREP_WORKSHEET_DATA =
  'AVAILABLE_KITCHEN_PREP_WORKSHEET_DATA';
export const AVAILABLE_KITCHEN_PREP_WORKSHEET_FETCHING_ERROR =
  'AVAILABLE_KITCHEN_PREP_WORKSHEET_FETCHING_ERROR';
export const CLEAR_AVAILABLE_KITCHEN_ERROR = 'CLEAR_AVAILABLE_KITCHEN_ERROR';
export const SET_TO_DATE_MIN = 'SET_TO_DATE_MIN';
export const SET_FROM_DATE_MAX = 'SET_FROM_DATE_MAX';
export const RESET_DATE_RANGE = 'RESET_DATE_RANGE';



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenprepworksheet/state/availableKitchenPrepWorksheet/types.js